/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { TurboScrollProps } from './TurboScrollProps';

import './TurboScroll.scss';

const TurboScroll: FunctionComponent<TurboScrollProps> = ({ channelNumber }): JSX.Element => {
    return <div className="channel-counter">{channelNumber}</div>;
};

TurboScroll.propTypes = {
    channelNumber: PropTypes.string.isRequired,
};

export default TurboScroll;
